module.exports = __webpack_public_path__ + "static/wt-ai-section-img-431ee697d323b10de5e5b9d3dd73aee9.jpg";